<template>
  <v-breadcrumbs id="breadcrumb" divider="/" :items="items">
    <template slot="item" slot-scope="props">
      <a @click="clickHandler(props.item.to)" :class="[props.item.disabled && 'disabled']">{{
        props.item.text
      }}</a>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    items: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    clickHandler(path) {
      // Redireccionamos

      this.$router.push(path);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
@import 'src/resources/styles/variables.scss';

#breadcrumb {
  padding: 0px !important;
  .disabled {
    color: grey;
    pointer-events: none;
  }
}
</style>
